<nav class="bottom-nav" fxLayout="row" fxLayoutAlign="center center">
  <ul>
    <li *ngFor="let item of navItems">
      <a data-cursor="cursor-link" [href]="currentRoute + '#' + item.id">
        {{ item.title }}
      </a>
    </li>
  </ul>
</nav>
